import axios from 'axios';
import { getProject } from './gcloud/getProject';

export default async function cloudFunctionGetService(functionName, projectUrl = getProject(), httpRequest = axios) {
  const config = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${Date.now()}`
  };

  return (await httpRequest({
    url: `${projectUrl}/${functionName}V2`,
    method: 'GET',
    headers: config,
  })).data
}